import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-marks",
  "use": "icon-marks-usage",
  "viewBox": "0 0 190.5 154.5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 190.5 154.5\" id=\"icon-marks\"><g><path d=\"M85.5,81L42,154.5L11,154.5L45.5,81L0,81L0,0L85.5,0L85.5,81ZM190.5,81L147,154.5L116,154.5L150.5,81L105,81L105,0L190.5,0L190.5,81Z\" fill=\"#DA241B\" fill-opacity=\"0.05000000074505806\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol